module.exports = __webpack_public_path__ + "img/2023-CNSRP.c2de22ac.jpg";